<p>LOGIN</p>
<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <label for="username">username: </label>
  <input id="username" type="text" formControlName="username" required/>
  <label for="password">password: </label>
  <input id="password" type="password" formControlName="password" required/>
  <button type="submit">Submit</button>
</form>

<button (click)="redirectToRegister()">OR REGISTER</button>
